import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=1f5deda7&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=1f5deda7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5deda7",
  null
  
)

export default component.exports